import { useBridge } from '@completeanatomy/bridge';
import { StorageProvider } from '@completeanatomy/storage';
import { Route } from '@completeanatomy/user-onboarding';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import useApp from '../../hooks/useApp';
import { useModelActivation } from '../../hooks/useModelActivation';
import { useScreenActivation } from '../../hooks/useScreenActivation';

export function MainPage() {
  const bridge = useBridge();
  const { app, deactivateApp } = useApp();
  const location = useLocation();

  useEffect(() => {
    window.deactivateApp = deactivateApp;
  }, [deactivateApp]);

  // Pass app to hooks to prevent duplicate app creation
  useScreenActivation(app);
  useModelActivation(app);

  useEffect(() => {
    const notify = (payload: any) => {
      bridge?.emit(payload['name'], payload['object']);
    };

    window.notify = notify;

    return () => {
      delete window.notify;
    };
  }, [bridge]);

  // Move consent banner into focus trap of profile survey page
  useEffect(() => {
    if (location.pathname !== `${Route.Base}/${Route.ProfileSurvey}`) {
      return;
    }

    const moveConsentBannerIntoFocusTrap = () => {
      const consentBanner = document.getElementById('onetrust-consent-sdk');
      const surveyContainer = document.querySelector(
        '[data-e2e="PageTemplate_Wrapper"]'
      );

      if (
        consentBanner &&
        surveyContainer &&
        consentBanner.parentElement !== surveyContainer
      ) {
        surveyContainer.append(consentBanner);
      }
    };

    const observer = new MutationObserver(moveConsentBannerIntoFocusTrap);

    moveConsentBannerIntoFocusTrap();
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <StorageProvider>
      <Outlet />
    </StorageProvider>
  );
}
